// Zugriff auf das Installationsangebot des Browsers.
//
// Chrome feuert "beforeinstallprompt" kurz nach dem Laden der Seite - oft
// schon, bevor React eingehaengt ist. Eine Komponente, die erst beim Mounten
// zu lauschen beginnt, verpasst das Ereignis und koennte die Installation
// danach nicht mehr anbieten. Deshalb wird hier beim Laden des Moduls
// gelauscht und das Ereignis aufbewahrt. index.js bindet die Datei so frueh
// wie moeglich ein.

let angebot = null;
const zuhoerer = new Set();

function melden() {
    zuhoerer.forEach((fn) => fn(angebot));
}

if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        // Ohne preventDefault zeigt Chrome sein eigenes Banner und das
        // Ereignis laesst sich spaeter nicht mehr ausloesen.
        e.preventDefault();
        angebot = e;
        melden();
    });

    window.addEventListener('appinstalled', () => {
        angebot = null;
        melden();
    });
}

export function holeAngebot() {
    return angebot;
}

// Liefert eine Abmeldefunktion zurueck, damit React beim Aufraeumen nicht
// auf eine ausgehaengte Komponente schreibt.
export function beiAngebot(fn) {
    zuhoerer.add(fn);
    return () => zuhoerer.delete(fn);
}

// Gibt zurueck, ob der Nutzer zugestimmt hat. Das Angebot laesst sich nur
// ein einziges Mal ausloesen - danach ist es verbraucht.
export async function installierenAnstossen() {
    if (!angebot) return false;
    const e = angebot;
    angebot = null;
    melden();
    e.prompt();
    const { outcome } = await e.userChoice;
    return outcome === 'accepted';
}

export function istInstalliert() {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true;
}

// "iPad" fehlt im User-Agent neuerer iPadOS-Versionen, dort hilft nur die
// Kombination aus Plattform und Touch-Faehigkeit.
export function istIOS() {
    if (typeof navigator === 'undefined') return false;
    return /iphone|ipod|ipad/i.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// Samsung Internet baut das WebAPK selbst und zielt dabei auf eine veraltete
// Android-Version. Android 14 verweigert die Installation solcher Pakete, und
// Google Play Protect meldet "Unsichere App blockiert". Chrome laesst das
// Paket dagegen auf einem Google-Dienst bauen, dort tritt das nicht auf.
// Deshalb wird dieser Browser gesondert behandelt.
export function istSamsungInternet() {
    if (typeof navigator === 'undefined') return false;
    return /SamsungBrowser/i.test(navigator.userAgent);
}

export function istAndroid() {
    if (typeof navigator === 'undefined') return false;
    return /android/i.test(navigator.userAgent);
}

export function istHandy() {
    return istIOS() || istAndroid();
}
